import React from 'react';
import {
  EdgeProps,
  getBezierPath,
  EdgeLabelRenderer,
  BaseEdge,
} from 'reactflow';
import { Chip } from '@mui/material';

const ConditionalEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const getConditionColor = (condition?: string) => {
    switch (condition) {
      case 'true':
      case 'success':
        return '#4CAF50';
      case 'false':
      case 'error':
        return '#F44336';
      default:
        return '#FF9800';
    }
  };

  const getConditionIcon = (condition?: string) => {
    switch (condition) {
      case 'true':
        return '✓';
      case 'false':
        return '✗';
      case 'success':
        return '✓';
      case 'error':
        return '⚠';
      default:
        return '?';
    }
  };

  const conditionColor = getConditionColor(data?.condition);

  return (
    <>
      <BaseEdge
        path={edgePath}
        style={{
          stroke: selected ? '#1976d2' : conditionColor,
          strokeWidth: selected ? 3 : 2,
          strokeDasharray: '5,5',
          opacity: 0.8,
        }}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
        >
          <Chip
            label={
              data?.label ||
              `${getConditionIcon(data?.condition)} ${data?.condition?.toUpperCase() || 'CONDITION'}`
            }
            size="small"
            style={{
              backgroundColor: conditionColor,
              color: 'white',
              fontSize: '0.65rem',
              height: 20,
              fontWeight: 'bold',
            }}
          />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default ConditionalEdge;
